import { PriceFeedSeeder } from './price-feed-seeder.cls'

/**
 * 
 */
export const NSSeeders = { 
  PriceFeedSeeder
}
